import React from 'react';
import {
  useGetDeviceCountLimitLazyQuery,
  useGetDevicesLazyQuery,
} from '../generated/graphql';
import { GraphQLErrorDialog } from '../components/Dialogs';
import { EmptyRow } from '../components/EmptyRow';
import { PageHeader } from '../components/PageHeader';
import { Loading } from '../Loading';
import { DeviceListHelper } from '../utils/DeviceListHelper';
import './DeviceStatusPage.css';
import { TableScroll } from '../components/TableScroll';

/** 表の列数。0件の行を表の幅いっぱいに広げるために使う */
const COLUMN_COUNT = 3;

/**
 * 台数使用状況。端末ごとの最終ログイン日と、契約台数の枠を使っているかを一覧にする。
 */
export const DeviceStatusPage: React.FC = function () {
  const [getDevices, getDevicesResult] = useGetDevicesLazyQuery();
  const [
    getDeviceCountLimit,
    getDeviceCountLimitResult,
  ] = useGetDeviceCountLimitLazyQuery();

  if (!getDevicesResult.called) {
    getDevices();
  }

  if (!getDeviceCountLimitResult.called) {
    getDeviceCountLimit();
  }

  if (getDevicesResult.error) {
    return <GraphQLErrorDialog error={getDevicesResult.error} />;
  }

  if (getDevicesResult.loading || !getDevicesResult.data) {
    return <Loading />;
  }

  // 台数の制限が未登録の環境ではgetDeviceCountLimitがエラーになるので、従来どおり0として扱う
  const effectiveDays =
    getDeviceCountLimitResult.data?.getDeviceCountLimit.effective_days ?? 0;
  const quantity =
    getDeviceCountLimitResult.data?.getDeviceCountLimit.quantity ?? 0;
  const helper = new DeviceListHelper(
    effectiveDays,
    quantity,
    getDevicesResult.data.getDevices
  );
  const devices = helper.getDevices();

  let rows;
  if (devices.length === 0) {
    rows = <EmptyRow colSpan={COLUMN_COUNT} message="端末が登録されていません" />;
  } else {
    rows = helper.getElementArray();
  }

  return (
    <div className="DeviceStatusPage">
      <PageHeader
        title="台数使用状況"
        breadcrumbs={[{ label: '管理画面' }, { label: '台数使用状況' }]}
      />
      <p className="DeviceStatusPage-summary">
        {helper.getUsingDeviceCount()}台使用中（契約台数: {quantity}台）
      </p>
      <p className="App-table_count">{devices.length} 件</p>
      <TableScroll storageKey="devices">
        <table className="App-table DeviceStatusPage-table">
          <thead>
            <tr>
              <th>ID</th>
              <th className="DeviceStatusPage-date_column">最終ログイン日</th>
              <th className="DeviceStatusPage-usage_column">使用状況</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </TableScroll>
    </div>
  );
};
